import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function DeckHeader() {
  return <section id="deckremodelingheader" data-nav="light" className="relative overflow-hidden bg-background text-foreground py-16 sm:py-20 lg:py-24">
      {/* 4D Isometric Glass Layered Planes (Decorative) */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
        <div className="absolute -top-24 right-1/4 h-96 w-96 rounded-full bg-chart-1/10 blur-3xl" />
        <div className="absolute top-1/2 -right-20 h-80 w-80 rounded-full bg-chart-2/5 blur-2xl" />
        <div className="absolute -bottom-16 left-10 h-72 w-72 rounded-full bg-accent/60 blur-2xl" />
        
        {/* Subtle geometric hairline grids */}
        <div className="absolute inset-0 bg-[radial-gradient(var(--border)_1px,transparent_1px)] [background-size:24px_24px] opacity-40" />
      </div>

      <div className="relative z-10 mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-2xl border border-border/80 bg-card/75 p-8 sm:p-12 lg:p-16 shadow-lg backdrop-blur-md">
          {/* Subtle architectural glass corner highlight */}
          <div className="pointer-events-none absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-border to-transparent" aria-hidden="true" />

          <div className="max-w-3xl space-y-6">
            {/* Breadcrumb Navigation */}
            <Breadcrumb>
              <BreadcrumbList className="text-xs sm:text-sm font-medium tracking-wide">
                <BreadcrumbItem>
                  <BreadcrumbLink asChild>
                    <Link to="/" className="text-muted-foreground hover:text-foreground transition-colors">
                      Home
                    </Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <span className="text-muted-foreground">Services</span>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  <BreadcrumbPage className="font-semibold text-foreground">
                    Deck Remodeling
                  </BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>

            {/* Main H1 Title */}
            <h1 className="font-serif text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl lg:text-6xl">
              Deck Remodeling in Decatur, GA
            </h1>

            {/* Intro Paragraph */}
            <p className="text-base text-muted-foreground sm:text-lg lg:text-xl leading-relaxed">
              Transform your outdoor living area with custom-built multi-level decks, covered porches, and premium composite decking engineered to complement your home’s architectural character and withstand Georgia’s climate.
            </p>
          </div>
        </div>
      </div>
    </section>;
}